module.exports = __webpack_public_path__ + "static/media/info-mobile.3a744e4b.svg";